<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-control">
                    <label for="checkoutCardNumber" class="form-label">Card Number</label>
                    <input v-model="card.number"
                           v-mask="'#### #### #### ####'"
                           v-validate="!isPaymentTypeAlreadySet ? 'required' : ''"
                           type="text"
                           placeholder="1234 5678 9012 3456"
                           name="card[number]"
                           :class="{'is-invalid': errors.has('card[number]')}"
                           id="checkoutCardNumber"
                           data-vv-as="Card Number">
                    <span class="validation-errors"
                          v-for="error in errors.collect('card[number]')">{{ error }}</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-control">
                    <label for="checkoutCardExpiryMonth" class="form-label">MM</label>
                    <input v-model="card.month"
                           v-mask="'##'"
                           v-validate="!isPaymentTypeAlreadySet ? 'required|min:2|max_value:12|min_value:1|numeric' : ''"
                           placeholder="12"
                           type="text"
                           autocomplete="cc-exp-month"
                           :class="{'is-invalid': errors.has('card[month]')}"
                           name="card[month]"
                           id="checkoutCardExpiryMonth"
                           data-vv-as="Expiry Month"
                           aria-label="Card expiry month"
                    >
                    <span class="validation-errors"
                          v-for="error in errors.collect('card[month]')">{{ error }}</span>
                </div>
            </div>
            <div class="col">
                <div class="form-control">
                    <label for="checkoutCardExpiryYear" class="form-label">YY</label>
                    <input v-model="card.year"
                           v-mask="'##'"
                           v-validate="!isPaymentTypeAlreadySet ? 'required|min:2|numeric' : ''"
                           placeholder="99"
                           maxlength="2"
                           type="text"
                           :class="{'is-invalid': errors.has('card[year]')}"
                           name="card[year]"
                           id="checkoutCardExpiryYear"
                           data-vv-as="Expiry Year"
                           aria-label="Card expiry year"
                    >
                    <span class="validation-errors"
                          v-for="error in errors.collect('card[year]')">{{ error }}</span>
                </div>
            </div>
            <div class="col">
                <div class="form-control">
                    <label for="checkoutCardCode" class="form-label">CVV/CVC</label>
                    <input v-model="card.cvv"
                           v-mask="'####'"
                           v-validate="!isPaymentTypeAlreadySet ? 'required|min:3|numeric' : ''"
                           type="text"
                           :class="{'is-invalid': errors.has('card[cvv]')}"
                           name="card[cvv]"
                           id="checkoutCardCode"
                           data-vv-as="CVV/CVC"
                           aria-label="Card Verification Code/Value"
                    >
                    <span class="validation-errors"
                          v-for="error in errors.collect('card[cvv]')">{{ error }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import paymentMethodMixin from "@mixins/paymentMethodMixin";

    export default {
        name: 'authorizeNetCreditCard',
        mixins: [paymentMethodMixin],
        data: () => ({
            card: {
                number: '',
                month: '',
                year: '',
                cvv: '',
            },
        }),
        computed: {
            authorizeNetAuthData() {
                return this.paymentMethod.public || null;
            }
        },
        methods: {
            async prePaymentRequest() {
                let cardData = {},
                    secureData = {};

                cardData.cardNumber = '' + this.card.number.replace(/\s+/g, '');
                cardData.month = '' + this.card.month.replace(/\s+/g, '');
                cardData.year = '' + this.card.year.replace(/\s+/g, '');
                cardData.cardCode = '' + this.card.cvv.replace(/\s+/g, '');
                secureData.authData = this.authorizeNetAuthData;
                secureData.cardData = cardData;

                return await new Promise((resolve, reject) => {
                    if (!this.authorizeNetAuthData) {
                        return reject(new Error("Payment gateway failure. Please try again later."));
                    }

                    if (this.isPaymentTypeAlreadySet) {
                        return resolve(true);
                    }

                    Accept.dispatchData(secureData, (response) => {
                        console.debug(response);
                        if (response.messages.resultCode === 'Error') {
                            let message = '';
                            let i = 0;
                            while (i < response.messages.message.length) {
                                message += response.messages.message[i].text + "\n";
                                i++;
                            }

                            if (!this.errors.count()) {
                                this.$scrollTo(`[name="card[number]"]`);
                            }
                            if (message) {
                                this.errors.add({
                                    field: 'card[number]',
                                    msg: message
                                });
                            }
                            this.$store.dispatch('checkout/fetchCheckout')
                            this.$store.dispatch('payment/reset');
                        } else {
                            this.$store.commit('payment/setPaymentType', this.paymentMethodName)
                            this.$store.commit('payment/setPaymentData', {
                                dataDescriptor: response.opaqueData.dataDescriptor,
                                dataValue: response.opaqueData.dataValue
                            })
                            return resolve(true)
                        }

                        return reject(false)
                    });
                })
            },
        }
    }
</script>
